import React from 'react';

function LoadingIndicator(props) {

    return (
        <div className="loader"/>
    );
}

export default LoadingIndicator;